export default __webpack_public_path__ + "static/artifakt-element-regular-d4382f25d953a9aa63b04da00632ac24.woff";